// Color Theme Configuration
// Central place to manage all colors used in the application

export const THEME = {
  // Primary Colors
  primary: {
    main: '#eb6c20',
    light: '#fdb11b',
    lighter: '#f6b28a',
    dark: '#c95b14',
  },

  // Secondary Colors
  secondary: {
    main: '#dad9da',
    light: '#f5f5f5',
    dark: '#7c7777',
  },

  // Neutral Colors
  neutral: {
    white: '#ffffff',
    black: '#000000',
    darkGray: '#222222',
    gray: '#333333',
    mediumGray: '#666666',
    lightGray: '#e6e6e6',
    border: '#cccccc',
    disabled: '#d0d0d0',
  },

  // Success Colors
  success: {
    main: '#27ae60',
    dark: '#229954',
    light: '#c8e6c9',
    background: '#e8f5e9',
  },

  // Error Colors
  error: {
    main: '#dc3545',
    dark: '#c0392b',
    darkText: '#721c24',
    light: '#f8d7da',
  },

  // Warning Colors
  warning: {
    main: '#ffc107',
    dark: '#856404',
    light: '#fff3cd',
  },

  // Info Colors
  info: {
    main: '#2196f3',
    dark: '#1976d2',
    light: '#e3f2fd',
    bright: '#007bff',
  },

  // Social Colors
  social: {
    whatsapp: '#25d366',
  },

  // Background Colors
  background: {
    default: '#ffffff',
    paper: '#ffffff',
    light: '#fffaf6',
    lightOrange: '#fff2e5',
    lightWarning: '#fff3cd',
    lightError: '#fff8f0',
  },

  // Text Colors
  text: {
    primary: '#333333',
    secondary: '#666666',
    disabled: '#999999',
    light: '#9d9d9d',
  },

  // Border Colors
  border: {
    default: '#cccccc',
    light: '#e0e0e0',
    primary: '#eb6c20',
    success: '#27ae60',
    error: '#dc3545',
    warning: '#ffc107',
    orange: '#ffcda6',
  },

  // Shadow & Effects
  shadow: {
    light: 'rgba(0, 0, 0, 0.06)',
    medium: 'rgba(0, 0, 0, 0.1)',
    dark: 'rgba(0, 0, 0, 0.15)',
    primary: 'rgba(235, 108, 32, 0.25)',
  },

  // Overlay Colors
  overlay: {
    dark: 'rgba(0, 0, 0, 0.5)',
  },

  // Drawer/Navigation Colors
  drawer: {
    background: '#eb6c20',
  },
};

// Helper function to get color value
export const getColor = (path) => {
  return path.split('.').reduce((obj, key) => obj?.[key], THEME);
};
